<template>
  <div
    class="base-input input-style base-select"
    :class="isSearch ? 'search-auto' : ''"
  >
    <v-autocomplete
      :items="items"
      outlined
      :placeholder="placeholder"
      dense
      height="36px"
      max-height="36px"
      :hide-details="hideDetails"
      :item-value="itemValue"
      :item-text="itemText"
      :value="value"
      :rules="rules"
      :multiple="multiple"
      @input="$emit('input', $event)"
      :append-icon="isSearch ? 'mdi-magnify' : 'mdi-chevron-down'"
    >
      <template v-if="isSlot" v-slot:item="{ item }">
        <span class="font-14">
          {{ item.name }} <span v-if="item.email">({{ item.email }})</span>
        </span>
        <slot />
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: "",
    },
    itemValue: {
      type: String,
      default: "value",
    },
    itemText: {
      type: String,
      default: "title",
    },
    value: {
      validator: () => true,
    },
    rules: {
      type: Array,
      default: () => [(v) => !!v || ""],
    },
    hideDetails: {
      type: Boolean,
      default: true,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    isSlot: {
      type: Boolean,
      default: false,
    },
    isSearch: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
.base-select {
  .v-input__slot {
    fieldset {
      height: 40px !important;
      border: 1px solid #e2e5ed !important;
    }
    .v-input__append-inner {
      margin-top: 5px !important;
    }
    .v-text-field__slot {
      height: 35px !important;
    }
  }
}
.search-auto {
  .v-autocomplete.v-select--is-menu-active .v-input__icon--append .v-icon {
    transform: none;
  }
}
</style>
